import { React,useEffect} from 'react';
import { useHistory } from "react-router";
import { makeStyles } from '@material-ui/core/styles';
import BottomNavigation from '@material-ui/core/BottomNavigation';
import BottomNavigationAction from '@material-ui/core/BottomNavigationAction';
import WhatshotIcon from '@material-ui/icons/Whatshot';
import MovieIcon from '@material-ui/icons/Movie';
import TvIcon from '@material-ui/icons/Tv';
import SearchIcon from '@material-ui/icons/Search';
import { useState } from 'react';
import FavoriteIcon from '@material-ui/icons/Favorite';
const useStyles = makeStyles({
  root: {
    width: "100vw",
    position : 'fixed',
    bottom : 0,
    backgroundColor: "#2d313a",
    zIndex: 100,
  },
});

export default function SimpleBottomNavigation() {
  const classes = useStyles();
  const [value, setValue] = useState(0);
  const history  = useHistory();
  useEffect(() => {
   if(value===0)history.push("/");
   else if(value===1)history.push("/Movies");
   else if(value===2)history.push("/Series");
   else if(value===3)history.push("/Search");
   else if(value===4)history.push("/FavMovs");
  }, [value,history]);

  return (
    <BottomNavigation
      value={value}
      onChange={(event, newValue) => {
        setValue(newValue);
      }}
      showLabels
      className={classes.root}
    >
      <BottomNavigationAction label="trending" style = {{color:'white'}} icon={<WhatshotIcon />} />
      <BottomNavigationAction label="Movies" style = {{color:'white'}} icon={<MovieIcon />} />
      <BottomNavigationAction label="TV series" style = {{color:'white'}} icon={<TvIcon />} />
      <BottomNavigationAction label="search" style = {{color:'white'}} icon={<SearchIcon />} />
      <BottomNavigationAction label="Favourite" style = {{color:'white'}} icon={<FavoriteIcon />} />
    </BottomNavigation>
  );
}
